import React from "react";
import {
  Button, TableRow, MenuItem, TextField, InputBase, TableCell, Typography, DialogTitle, DialogContent, DialogActions, TableSortLabel, CircularProgress,
  DialogContentText, Select, Box, Stack, List, Card, CardHeader, ListItemButton, ListItemText, ListItemIcon, Checkbox, Divider, FormControlLabel, Tooltip, 
  IconButton } from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { tableSortLabelClasses } from "@mui/material/TableSortLabel";
import { ArrowDownward, ArrowUpward, CloudUpload } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import _ from "underscore";

// const env = 'tribunal'
const env = "pacientcare";
const host = 'https://api.mgm.patientcare.com.br/'
//const host = "http://10.18.166.55:9001/";
const public_link_for_candidate = "https://mgm.patientcare.com.br/candidate?r="
const labels = {
  tribunal: {
    navImg: "/static/wscover.webp",
    coverImg: "/static/wscover.webp",
    companyLabel: "Tribunal",
    companyNotFound: "Nenhum tribunal",
  },
  pacientcare: {
    navImg: "/static/logonavbar.png",
    coverImg: "/static/loginimage.webp",
    companyLabel: "Empresa",
    companyNotFound: "Nenhuma empresa",
  },
};
const acceptableImagesTypes = ".jpg, .png, .jpeg"
const DocumentType = { "-1": "Indefinido", "1": "Anamnese", "2": "Ficha de Avaliação", "3": "Ficha de Tratamento", "4": "POP", "5": "Contrato", "6": "TCLE", "7": "Pós-Tratamento", "8": "Representante Legal", "9": "Identidade", "10": "Template de Anamnese", "11": "Template de Ficha de Avaliação", "12": "Template de Ficha de Tratamento", "13": "Template de Contrato", "14": "Template de TCLE", "15": "Template de Pós-Tratamento", "16": "Template de Representante Legal", "17": "Foto", "18": "Logomarca" } 
const DoctorType = {"-1": "Indefinido", "1": "Farmacêutico Esteta", "2": "Esteticista", "3": "Biomédico", "4": "Dentista", "5": "Enfermeiro", "6": "Massoterapeuta"};
// Begin - This is repeated at ~/api/app/Controllers/Http/DocumentController.js, update it there too!
const MaritalStatusType = {"-1": "Indefinido", "1": "Solteiro", "2": "Casado", "3": "Separado", "4": "Divorciado", "5": "União Estável", "6": "Viúvo"};
const AllowedToPostType = {"1": "Total", "2": "Parcial", "3": "Nenhum"}
// End - This is repeated at ~/api/app/Controllers/Http/DashboardController.js
// Begin - This is repeated at ~/api/app/Controllers/Http/DocumentController.js, update it there too!
const GenderType = {"-1": "Indefinido", "1": "Feminino", "2": "Masculino"}
// End - This is repeated at ~/api/app/Controllers/Http/DashboardController.js
const QuestionType = {"-1":"Indefinido", "1": "RadioButton", "2": "Slidebar", "3": "Checkbox", "4": "Editbox"};
export const C = {
  baseURL: host,
  appName: "PatientCare",
  appVersion: "v1.0.0",
  navImg: labels[env].navImg,
  coverImg: labels[env].coverImg,
  companyLabel: labels[env].companyLabel,
  companyNotFound: labels[env].companyNotFound,
  acceptableImagesTypes: acceptableImagesTypes,
  AllowedToPostType: AllowedToPostType,
  DocumentType: DocumentType,
  DoctorType: DoctorType,
  MaritalStatusType: MaritalStatusType,
  GenderType: GenderType,
  QuestionType: QuestionType,
  public_link_for_candidate: public_link_for_candidate,
};

export class ConfirmDialog extends React.Component {
  render() {
    return (
      <D className="col e aF pa">
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent style={{ minWidth: "25vw" }}>
          {!!this.props.msg && (
            <>
              <DialogContentText>{this.props.msg}</DialogContentText>
              <D h="1rem" />
            </>
          )}
          {!!this.props.reg && (
            <>
              <DialogContentText align="center" variant="h6">
                {this.props.reg}
              </DialogContentText>
              <D h="1rem" />
            </>
          )}
          <>{this.props.children}</>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={this.props.onCancel}
          >
            {typeof this.props.onConfirm === "function" ? "Cancelar" : "Fechar"}
          </Button>
          {typeof this.props.onConfirm === "function" && (
            <Button
              variant="outlined"
              color="primary"
              onClick={this.props.onConfirm}
            >
              Confirmar
            </Button>
          )}
        </DialogActions>
      </D>
    );
  }
}
export class HardConfirmDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { confirmed: false}
  }
  render() {
    return (
      <D className="col e aF pa">
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent style={{ minWidth: "25vw" }}>
          {!!this.props.msg && (
            <>
              <DialogContentText>{this.props.msg}</DialogContentText>
              <D h="1rem" />
            </>
          )}
          {!!this.props.reg && (
            <>
              <DialogContentText align="center" variant="h6">
                {this.props.reg}
              </DialogContentText>
              <D h="1rem" />
            </>
          )}
          <>{this.props.children}</>
          <FormControlLabel 
            control={
              <Checkbox 
                checked={this.state.confirmed} 
                onChange={(e) => this.setState({ confirmed: e.target.checked ? true : false } )} 
              />
            }
            label="Estou consciente do que estou fazendo" 
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={this.props.onCancel}
          >
            {typeof this.props.onConfirm === "function" ? "Cancelar" : "Fechar"}
          </Button>
          {typeof this.props.onConfirm === "function" && (
            <Button
              variant="outlined"
              color="primary"
              onClick={this.props.onConfirm}
              disabled={this.state.confirmed ? false : true}
            >
              Confirmar
            </Button>
          )}
        </DialogActions>
      </D>
    );
  }
}
export class MessageDialog extends React.Component {
  render() {
    return (
      <D className="col e aF pa">
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent style={{ minWidth: "25vw" }}>
          {!!this.props.msg && (
            <>
              <DialogContentText>{this.props.msg}</DialogContentText>
              <D h="1rem" />
            </>
          )}
          {!!this.props.reg && (
            <>
              <DialogContentText align="center" variant="h6">
                {this.props.reg}
              </DialogContentText>
              <D h="1rem" />
            </>
          )}
          <>{this.props.children}</>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.onOk}>
            {typeof this.props.onOk === "function" ? "OK" : "Fechar"}
          </Button>
        </DialogActions>
      </D>
    );
  }
}
export const TCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#424242",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    whiteSpace: "nowrap",
    wordWrap: "normal",
  },
}));
export const TSortLabel = styled(TableSortLabel)(({ theme }) => ({
  [`&.${tableSortLabelClasses.root}`]: {
    color: theme.palette.common.white,
    "& $icon": {
      color: theme.palette.common.white,
    },
    "&:hover": {
      color: theme.palette.common.white,
      "&& $icon": {
        color: theme.palette.common.white,
      },
    },
    "&$active": {
      color: theme.palette.common.white,
      "&& $icon": {
        color: theme.palette.common.white,
      },
    },
  },
  [`&.${tableSortLabelClasses.active}`]: {},
  [`& .${tableSortLabelClasses.icon}`]: {
    color: theme.palette.common.white,
    "& path": {
      fill: "#eee",
    },
  },
}));
export const TRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
export class SearchField extends React.Component {
  render() {
    return (
      <D
        className="row e aS"
        style={{
          minWidth: "100px",
          maxWidth: "500px",
          padding: "3px 7px 2px 7px",
          borderRadius: "0.5rem",
          backgroundColor: "#eeeeee",
          "&:hover": {
            backgroundColor: "#e0e0e0",
          },
        }}
      >
        <InputBase
          style={{ color: "inherit", width: "100%" }}
          placeholder="Buscar..."
          value={this.props.value}
          onChange={(e) => this.props.onChange(e.target.value)}
        />
      </D>
    );
  }
}
export class SearchFieldMediateca extends React.Component {
  render() {
    return (
      <D
        className="row e aS"
        style={{
          minWidth: "100px",
          maxWidth: "500px",
          padding: "3px 7px 2px 7px",
          borderRadius: "0.5rem",
          backgroundColor: "#eeeeee",
          "&:hover": {
            backgroundColor: "#e0e0e0",
          },
        }}
      >
        <D size="1rem" />
        <InputBase
          style={{ color: "inherit", width: "100%" }}
          placeholder="Buscar..."
          value={this.props.value}
          onChange={(e) => this.props.onChange(e.target.value)}
        />
      </D>
    );
  }
}
export class Input extends React.Component {
  constructor(props) {
    super(props);
    this.importedProps = _.pick(this.props, [
      "id",
      "name",
      "rows",
      "type",
      "label",
      "color",
      "onBlur",
      "select",
      "onFocus",
      "rowsMax",
      "children",
      "disabled",
      "inputRef",
      "onChange",
      "required",
      "autoFocus",
      "className",
      "fullWidth",
      "multiline",
      "inputProps",
      "InputProps",
      "placeholder",
      "SelectProps",
      "autoComplete",
      "defaultValue",
      "inputlabelprops",
      "FormHelperTextProps",
    ]);
  }
  render() {
    const errorMessage = this.props.errorMessage;
    return (
      <D className="col w aF">
        <TextField
          {...this.importedProps}
          variant={!!this.props.variant ? this.props.variant : "outlined"}
          margin={!!this.props.margin ? this.props.margin : "none"}
          onChange={(e) => this.props.onChange(e.currentTarget.value)}
        />
        {!!errorMessage && (
          <>
            <D h="3px" />
            <D className="row w aC">
              <Typography variant="caption">{errorMessage}</Typography>
            </D>
            <D h="10px" />
          </>
        )}
      </D>
    );
  }
}
export class CustomSelect extends React.Component {
  render() {
    return (
      <Select
        id={this.props.id ? this.props.id : ''}
        value={(this.props.options.length>0) ? this.props.value : ''}
        label={(this.props.options.length>0) ? this.props.label : ''}
        type="text"
        inputlabelprops={this.props.inputlabelprops}
        className="Input"
        inputProps={{ className: this.props.className }}
        style={{
          ...this.props.style,
          width: !!this.props.width ? this.props.width : "100%",
        }}
        placeholder={this.props.placeholder}
        disabled={!!this.props.disabled ? true : false}
        variant="outlined"
        size={!!this.props.heightSize ? this.props.heightSize : "medium"}
        color="primary"
        margin={!!this.props.margin ? this.props.margin : "none"}
        onChange={(e) => this.props.onChange(e.target.value)}
      >
        {typeof this.props.options === "object" &&
          this.props.options.length > 0 &&
          this.props.options.map((o) => {
            if (typeof o === "object") {
              const [k, v] = Object.entries(o)[0];
              return (
                <MenuItem key={k} value={k}>
                  {v}
                </MenuItem>
              );
            } else {
              return (
                <MenuItem key={o} value={o}>
                  {o}
                </MenuItem>
              );
            }
          })}
      </Select>
    );
  }
}
export class CenterContent extends React.Component {
  render() {
    return (
      <D
        e
        className={
          "row aF " + (!!this.props.background ? this.props.background : "")
        }
      >
        {/* <D e className="hide-lg" /> */}
        <D e className="hide-xlg" />
        <D e />
        <div
          onClick={this.props.onClick}
          onChange={this.props.onChange}
          onMouseDown={this.props.onMouseDown}
          id={this.props.id}
          className={this.props.className}
          style={{
            ...this.props.style,
            ...{
              flex: !!this.props.p ? this.props.p : 1,
              maxWidth: this.props.size,
            },
          }}
        >
          {this.props.children}
        </div>
        <D e />
        <D e className="hide-xlg" />
        {/* <D e className="hide-lg" /> */}
      </D>
    );
  }
}
export class Loading extends React.Component {
  render() {
    return (
      <D className="row e aC" style={this.props.style}>
        <CircularProgress />
      </D>
    );
  }
}
export class D extends React.Component {
  render() {
    return (
      <div
        onClick={this.props.onClick}
        onChange={this.props.onChange}
        onMouseDown={this.props.onMouseDown}
        onMouseMove={this.props.onMouseMove}
        onMouseUp={this.props.onMouseUp}
        id={this.props.id}
        className={
          !!this.props.hide
            ? "hide"
            : (!!this.props.row ? "row " : "") +
              (!!this.props.col ? "col " : "") +
              (!!this.props.e ? "e " : "") +
              (!!this.props.w ? "w " : "") +
              (!!this.props.cover ? "coverImg " : "") +
              (!!this.props.side ? "sideImg " : "") +
              (!!this.props.className ? this.props.className : "")
        }
        style={{
          ...(!this.props.p ? {} : { flex: this.props.p }),
          ...(!this.props.h ? {} : { minHeight: this.props.h }),
          ...(!this.props.size
            ? {}
            : {
                flexBasis: this.props.size,
                minWidth: this.props.size,
                maxWidth: this.props.size,
              }),
          ...(!this.props.img
            ? {}
            : { backgroundImage: 'url("' + this.props.img + '")' }),
          ...this.props.style,
        }}
      >
        {!!this.props.imc ? (
          <img alt="" src="/static/img/zero.png" className="icn-xmc" />
        ) : null}
        {this.props.children}
      </div>
    );
  }
}
export const obj2form = (d) => {
  let l = new FormData();
  Object.entries(d).forEach((e) => {
    const [k, v] = e;
    l.append(k, v);
  });
  return l;
};
const toHex = (c) => "#" + ((c[0] << 16) | (c[1] << 8) | c[2]).toString(16);
const toRgb = (hex) => {
  let r = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return r ? [parseInt(r[1], 16), parseInt(r[2], 16), parseInt(r[3], 16)] : [];
};
const interpolateColor = (c1, c2, factor) => {
  var result = c1.slice();
  for (var i = 0; i < 3; i++) {
    result[i] = Math.round(result[i] + factor * (c2[i] - c1[i]));
  }
  return result;
};
export const getColors = (l, color1, color2) => {
  let stepFactor = 1 / (l - 1),
    inter = [];
  color1 = toRgb(color1); //.match(/\d+/g).map(Number)
  color2 = toRgb(color2); //.match(/\d+/g).map(Number)
  for (var i = 0; i < l; i++) {
    inter.push(toHex(interpolateColor(color1, color2, stepFactor * i)));
  }
  return inter;
};
export const getColorsByClass = (l, color1, color2) => {
  let myPalette = [];
  let colors = [
    toHex([31, 119, 180]),
    toHex([255, 127, 14]),
    toHex([44, 160, 44]),
    toHex([214, 39, 40]),
    toHex([148, 103, 189]),
    toHex([140, 86, 75]),
    toHex([227, 119, 194]),
    toHex([127, 127, 127]),
    toHex([188, 189, 34]),
    toHex([23, 190, 207]),
    toHex([177, 89, 40]),
  ];
  for (var i = 0; i < l; i++) {
    myPalette.push(colors[i % colors.length]);
  }
  console.log(myPalette);
  return myPalette;
};
export const checker = (ss, sf) =>
  !sf ? true : !!_.compact(sf.split(" ")).every((e) => ss.includes(e));
export const openLink = (t) => window.open(t, "_blanck");


export class TransferList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: [],
      alternative: this.props.alternative ? this.props.alternative : [0,1,2,3],
      assignment: this.props.assignment ? this.props.assignment : [4,5,6,7],
      caption: this.props.caption ? this.props.caption : 'Escolha'
    };
  }
  
  not(a, b) {
    return a.filter((value) => !b.includes(value));
  }
  
  intersection(a, b) {
    return a.filter((value) => b.includes(value));
  }
  
  union(a, b) {
    return [...a, ...this.not(b, a)];
  }
  
  alternativeChecked = () => ( this.intersection(this.state.checked, this.state.alternative) );
  assignmentChecked = () => ( this.intersection(this.state.checked, this.state.assignment) );
 
  handleToggle = (value) => () => {
    const currentIndex = this.state.checked.indexOf(value);
    const newChecked = [...this.state.checked];
  
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
  
    this.setState({ checked: newChecked });
  };
  
  numberOfChecked = (items) => this.intersection(this.state.checked, items).length;
  
  handleToggleAll = (items) => () => {
    if (this.numberOfChecked(items) === items.length) {
      this.setState({ checked: this.not(this.state.checked, items) });
    } else {
      this.setState({ checked: this.union(this.state.checked, items) });
    }
  };
  
  handleCheckedAssignment = () => {
    this.setState({ assignment: this.state.assignment.concat(this.intersection(this.state.checked, this.state.alternative)) }, this.stateCallback);
    this.setState({ alternative: this.not(this.state.alternative, this.intersection(this.state.checked, this.state.alternative)) });
    this.setState({ checked: this.not(this.state.checked, this.intersection(this.state.checked, this.state.alternative)) });
  };
  
  handleCheckedAlternative = () => {
    this.setState({ alternative: this.state.alternative.concat(this.intersection(this.state.checked, this.state.assignment)) });
    this.setState({ assignment: this.not(this.state.assignment, this.intersection(this.state.checked, this.state.assignment)) }, this.stateCallback);
    this.setState({ checked: this.not(this.state.checked, this.intersection(this.state.checked, this.state.assignment)) });
  };
 
  stateCallback= () => {
    this.props.onAssignmentChange(this.state.assignment);
  };
  
  customList = (title, items) => (
    <Card>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={this.handleToggleAll(items)}
            checked={this.numberOfChecked(items) === items.length && items.length !== 0}
            indeterminate={
              this.numberOfChecked(items) !== items.length && this.numberOfChecked(items) !== 0
            }
             disabled={items.length === 0}
             inputProps={{
               'aria-label': 'todos itens selecionados',
             }}
           />
         }
         title={title}
         subheader={`${this.numberOfChecked(items)}/${items.length} selecionados`}
       />
       <Divider />
       <List
         sx={{
           width: "100%",
           height: 230,
           bgcolor: 'background.paper',
           overflow: 'auto',
         }}
         dense
         component="div"
         role="list"
       >
         {items.map((value) => {
           const labelId = `transfer-list-all-item-${value}-label`;

           return (
             <ListItemButton
              key={value}
              role="listitem"
              onClick={this.handleToggle(value)}
             >
               <ListItemIcon>
                <Checkbox
                  checked={this.state.checked.includes(value)}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={value} />
            </ListItemButton>
          );
        })}
      </List>
    </Card>
  );

  render() {
    return (
      <Stack spacing={2}>
        <Divider />
        <D className="col e aC">
          <Typography gutterBottom component='div'><Box fontWeight='fontWeightMedium'>{this.state.caption}</Box></Typography>
        </D>
         {this.customList('Alternativas', this.state.alternative)}
        <D className="col e aC">
           <Stack spacing={2} direction="row">
             <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={this.handleCheckedAssignment}
              disabled={this.intersection(this.state.checked, this.state.alternative).length === 0}
              aria-label="move selected assignment"
              startIcon={<ArrowDownward />}
            />
            <Button
              sx={{ my: 0.5 }}
              variant="outlined"
              size="small"
              onClick={this.handleCheckedAlternative}
              disabled={this.intersection(this.state.checked, this.state.assignment).length === 0}
              aria-label="move selected alternativa"
              startIcon={<ArrowUpward />}
            />
          </Stack>
        </D>
        {this.customList('Designações', this.state.assignment)}
      </Stack>
    );
  }
}


export class UploadFiles extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      multipleFiles: this.props.multiple ? this.props.multiple : false,
      progress: 100,
      display: "Selecione o arquivo",
      chunkSize: this.props.chunkSize ? this.props.chunkSize : (1 * 1024 * 1024), //1MB
      maxFileSizeMB: this.props.maxFileSizeMB ? this.props.maxFileSizeMB : 5, //5MB
      acceptableFileTypes : this.props.acceptableFileTypes ? this.props.acceptableFileTypes : ".jpg, .png, .jpeg, .pdf, .mp4",
      registerIntoDB: this.props.registerIntoDB ? this.props.registerIntoDB : false,
      caption: this.props.caption ? this.props.caption : '',
    };
  }  

  handleFileUploadList = (upload_lst) => {
    //Check if files size do not exceeed the maximum value
    var filesToUpload = [];
    Array.prototype.forEach.call(upload_lst, file => {
      if(file.size > (this.state.maxFileSizeMB * 1024 * 1024))
         this.props.alert("Arquivo " + file.name + " excede o tamanho máximo de " + this.state.maxFileSizeMB +"MB");
      else
        filesToUpload.push(file);
    } );

    //Ready to upload
    for(let i in filesToUpload)
      this.sendFile(filesToUpload[i]);
  };
  
  sendFile = (file) => {
    const totalChunks = Math.ceil(file.size / this.state.chunkSize);
    let chunkNumber = 0;
 
    const uploadChunk = async (chunk, chunkNumber, totalChunks) => {
      const formData = new FormData();
      formData.append('chunk', chunk);
      formData.append('chunkNumber', chunkNumber);
      formData.append('totalChunks', totalChunks);
      formData.append('fileName', file.name);
      formData.append('type', file.type);
      formData.append('registerIntoDB', this.state.registerIntoDB);
  
      this.props.api.post('/FileServer/upload', formData, { 
        headers: {
          'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT', 'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, x-client-key, x-client-token, x-client-secret, Authorization'
        }
      })
      .then((response) => {
        if (response.status === 200) {
          //console.log(`Chunk ${chunkNumber + 1} de ${totalChunks} enviado com sucesso`);
          chunkNumber++;
          if (chunkNumber < totalChunks) {
            const start = chunkNumber * this.state.chunkSize;
            const end = Math.min(file.size, start + this.state.chunkSize);
            const nextChunk = file.slice(start, end);
            this.setState({progress: Math.round(chunkNumber/totalChunks*100), display: file.name });
            uploadChunk(nextChunk, chunkNumber, totalChunks);
          } else {
            //console.log('Upload completo');
            this.setState({progress: 100, display: file.name });
            //console.log("db_record",response.db_record);
            this.props.onFinish(response.db_record,false);
          }
        }
        else {
          //console.log('Erro no upload do chunk:', response.statusText);
          this.setState({progress: 100, display: file.name + " - Upload do chunk falhou" });
          this.props.onFinish({},true);
        }
      })
      .catch((error) => {
        //console.log('Erro:', error.message);
        this.setState({progress: 100, display: file.name + " - Upload falhou" });  
        this.props.onFinish({},true);      
      })
    };    

 
    const firstChunk = file.slice(0, this.state.chunkSize);
    uploadChunk(firstChunk, chunkNumber, totalChunks);     
  };

  
  render() {
    return (
      <D className="col e aF scD" style={{ padding: "0.5rem" }}>
        <D className="col w aF">
          <Typography>{this.state.caption}</Typography>
          <D className="row w aF">
            <D className="e hide-md" />            
              <>
                { (this.state.progress === 100) &&
                <D className="row">
                  <Tooltip title="Enviar documento" arrow>
                    <IconButton
                      component="label"
                    >
                      <CloudUpload />
                      <input
                        styles={{display:"none"}}
                        type="file"
                        multiple={this.state.multipleFiles}
                        hidden
                        accept={this.state.acceptableFileTypes}
                        onChange={(e) => this.handleFileUploadList(e.target.files)}
                        id="file-upload-input"
                      />
                    </IconButton>
                  </Tooltip>
                  <Typography gutterBottom sx={{ color: 'text.secondary', marginTop: '8px' }}>{this.state.display}</Typography>
                </D>
                }
                { (this.state.progress !== 100) &&
                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                  <CircularProgress variant="determinate" value={this.state.progress} />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: 'absolute',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography variant="caption" component="div" sx={{ color: 'text.secondary' }}>
                      {"" + this.state.progress + "%"}
                    </Typography>
                  </Box>
                </Box>
                }
             </>
            <D className="e hide-md" />
          </D>
        </D>
      </D>
    );
  }
}
